import DS82StuckBot from "./DS82StuckBot.page";

export default DS82StuckBot;
